module.exports = __webpack_public_path__ + "static/media/RDMVS.38776b92.png";